import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { UploadFilesSimpleField } from 'components/FormFieldsSimple/UploadFilesSimpleField';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

const staticInitial = [];

export class UploadFilesField extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    input: PropTypes.object,
    meta: PropTypes.object,
  };

  static defaultProps = {
    input: {},
    meta: {},
  };

  handleChange = (value) => {
    const { input } = this.props;
    input.onFocus();
    input.onChange(value);
    input.onBlur();
  };

  render() {
    const { meta, input } = this.props;
    let { initial } = meta;

    return (
      <ReduxFormElementWrapper
        {...this.props}
        testId={`upload-files-${input.name}`}
        childrenMarginTop="20px"
        bottomErrorClassName="ml-7"
      >
        <UploadFilesSimpleField
          {...this.props}
          onChange={this.handleChange}
          initial={initial || staticInitial}
        />
      </ReduxFormElementWrapper>
    );
  }
}
